import type { ConceptDef } from '../types';

export const echoicTongueTwisters: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-tongue-twisters',
  label: 'Echoic Tongue Twisters',
  category: 'Echoic',
  description: 'Speak a tongue twister; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'She sells sea shells.' },
      { prompt: 'Red leather, yellow leather.' },
      { prompt: 'Peter Piper picked a peck.' },
      { prompt: 'Unique New York.' },
      { prompt: 'Toy boat, toy boat, toy boat.' },
    ],
  },
};
